module.exports = __webpack_public_path__ + "static/media/correct-icon.12cefa10.svg";